import React from 'react';
import { UserProfile } from '@clerk/clerk-react';
import { Link } from 'react-router-dom';

export default function ProfilePage() {
  return (
    <div>
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Profile Settings</h1>
        <p className="text-gray-600 dark:text-gray-400 dark:text-gray-300 dark:text-gray-600">
          Manage your account settings and profile information
        </p>
      </div>

      {/* Navigation Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {/* Account Settings Card */}
        <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700 shadow-sm">
          <div className="flex items-center mb-4">
            <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-white dark:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <h3 className="ml-3 text-lg font-medium text-gray-900 dark:text-white">Account Settings</h3>
          </div>
          <p className="text-gray-600 dark:text-gray-400 mb-4 dark:text-gray-300 dark:text-gray-600">
            Manage your authentication settings, email, password, and security preferences.
          </p>
          <div className="text-sm text-gray-500 dark:text-gray-500">
            Managed by Clerk Authentication
          </div>
        </div>

        {/* Profile Details Card */}
        <Link 
          to="/profile/details" 
          className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700 hover:border-teal-500 dark:hover:border-teal-500 transition-colors group shadow-sm"
        >
          <div className="flex items-center mb-4">
            <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center group-hover:bg-blue-500 transition-colors">
              <svg className="w-5 h-5 text-white dark:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 8h1m-1-4h1m4 4h1m-1-4h1" />
              </svg>
            </div>
            <h3 className="ml-3 text-lg font-medium text-gray-900 dark:text-white group-hover:text-teal-400 transition-colors">
              Profile Details
            </h3>
          </div>
          <p className="text-gray-600 dark:text-gray-400 mb-4 dark:text-gray-300 dark:text-gray-600">
            Update your business information, address, and other profile details.
          </p>
          <div className="flex items-center text-teal-400 text-sm font-medium">
            Manage Details
            <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </Link>
      </div>

      {/* Clerk User Profile Component */}
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-700 shadow-sm">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">Account Authentication</h2>
        <div className="clerk-profile-container w-full">
          <div className="w-full">
            <UserProfile path="/profile" routing="path" />
          </div>
        </div>
      </div>
    </div>
  );
}
